'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  service('orderService', function (accessControl, userService, $http, $stateParams, $cookies, $q, Restangular, geolocation, $timeout) {

    /**** Save a order ****/
    var saveOrder = function (order, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var order = angular.copy(order);
      var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');

      if (order.orderNumber == "") {
        delete order.orderNumber;
      }

      // update line items to have id's for ref'd items - not objects
      if (order.lineItems != null) {
        for (var i = 0; i < order.lineItems.length; i++) {
          if (order.lineItems[i].resource) {
            order.lineItems[i].resource = order.lineItems[i].resource.id;
          }
          if (order.lineItems[i].new == true) {
            delete order.lineItems[i].id;
            delete order.lineItems[i].new;
          }
          if (order.lineItems[i].quantity) {
            order.lineItems[i].quantity = parseFloat(order.lineItems[i].quantity);
          }

          if (order.lineItems[i].rate) {
            order.lineItems[i].rate = parseFloat(order.lineItems[i].rate);
          }
        }
      }

      // docket prefill field stores - update any date fields and save in correct format
      /*if ( order.docketPrefillValueStore && order.template ) {
        var prefillKeys = Object.keys(order.docketPrefillValueStore);
        for ( var i = 0; i < prefillKeys.length; i++ ) {
          // check against template if this field id is a date field
          for ( var j = 0; j < order.template.blocks.length; j++ ) {
            for ( var k = 0; k < order.template.blocks[j].fields.length; k++ ) {
              if ( order.template.blocks[j].fields[k].id == prefillKeys[i] && order.template.blocks[j].fields[k].type == 'date' ) {
                var preValue = order.docketPrefillValueStore[prefillKeys[i]];
                var translatedValue = moment(preValue).format('YYYY-MM-DD');
                translatedValue += "T00:00:00.000Z";
                order.docketPrefillValueStore[prefillKeys[i]] = translatedValue;
                console.log('translated this prefill field date field type to', translatedValue);
              }
            }
          }
        }
      }*/

      // convert dates to ISO format
      if (order.startDate) {
        order.startDate = moment(order.startDate).format('YYYY-MM-DD');
      }
      if (order.endDate) {
        order.endDate = moment(order.endDate).format('YYYY-MM-DD');
      }

      // strip out customer field if customer linking no create
      // TODO: remove this after new address book is implemented
      if (order.customer == "") {
        delete order.customer;
      }

      if (order.template != null && order.template.id != null) {
        order.template = order.template.id;
      }

      if (order.template == null) {
        delete order.template;
      }

      if (order.customerContact == null) {
        delete order.customerContact;
      } else {
        for (var i = 0; i < order.customerContact.addresses.length; i++) {
          if (order.customerContact.addresses[i].streetNum == null) {
            delete order.customerContact.addresses[i].streetNum;
          }
          if (order.customerContact.addresses[i].streetName == null) {
            delete order.customerContact.addresses[i].streetName;
          }
        }
      }

      if (order.orderNumber == 'New Order') {
        delete order.orderNumber;
      }

      // strip out dockets array
      delete order.dockets;

      // if current group is the supplier contact - add org and org group to the order
      var currentOrg = organisation;
      var currentOrgGroup = organisationGroup;
      if (!order.organisation || !order.organisationGroup) {
        if (currentOrgGroup.emailAddresses && order.supplierContact && order.supplierContact.contactAddresses) {
          var foundEmail = false;
          for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
            if (order.supplierContact.contactAddresses[currentOrgGroup.emailAddresses[i]] != null) {
              foundEmail = true;
              break;
            }
          }
          if (foundEmail) {
            order.organisation = currentOrg.id;
            order.organisationGroup = currentOrgGroup.id;
          }
        }
      }
      if (order.id == null) {
        order.status = 'Draft';
        if (order.orderNumber == 'New Order') {
          delete order.orderNumber;
        }
        // strip out any line items that have been deleted
        var lineItemsActual = [];
        if (order.lineItems) {
          for (var i = 0; i < order.lineItems.length; i++) {
            if (!order.lineItems[i].delete) {
              lineItemsActual.push(order.lineItems[i]);
            }
          }
          order.lineItems = lineItemsActual;
        }
        baseOrders.post(order).then(successCb, failureCb);
      } else {
        // existing order - edit
        baseOrders.one(order.id).customPUT(order).then(successCb, failureCb);
      }
    }

    /**** External ref to saveOrder ****/
    this.saveOrder = saveOrder;

    /***** Get Single Template *****/
    var getTemplate = function (templateId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');
      if (templateId != null && templateId.id != null) {
        templateId = templateId.id;
      }
      baseTemplates.one(templateId).get().then(function (templateFull) {
        successCb(templateFull);
      }, failureCb);
    }

    /***** External ref to getTemplate *****/
    this.getTemplate = getTemplate;

    /***** Get Single Order *****/
    var getOrder = function (orderId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();

      var baseOrders = null;
      var baseTemplates = null;
      if (organisation != null) {
        baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
        baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');
      } else {
        baseOrders = Restangular.all('orders');
      }

      //var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
      //var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');
      if (orderId.id != null) {
        orderId = orderId.id;
      }
      baseOrders.one(orderId).get().then(function (fullOrder) {
        // convert dates
        if (fullOrder.startDate) {
          fullOrder.startDate = moment(fullOrder.startDate).toDate();
        }
        if (fullOrder.endDate) {
          fullOrder.endDate = moment(fullOrder.endDate).toDate();
        }

        // if template not populated - get full template
        // uppercase status
        fullOrder.status = fullOrder.status.charAt(0).toUpperCase() + fullOrder.status.slice(1);
        if (fullOrder.template != null && fullOrder.template.id == null && baseTemplates != null && userService.userCanDoAction('isOrderSupplier', fullOrder)) {
          getTemplate(fullOrder.template, function (fullTemplate) {
            fullOrder.template = Restangular.stripRestangular(fullTemplate);
            successCb(fullOrder);
          }, function (err) {
            successCb(fullOrder);
          });
        } else {
          successCb(fullOrder);
        }
      }, failureCb);
    }

    this.getOrder = getOrder;

    /****** Delete Single Order *****/
    var deleteOrder = function (orderId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');

      if (orderId.id != null) {
        orderId = orderId.id;
      }

      baseOrders.one(orderId).remove().then(successCb, failureCb);
    }

    this.deleteOrder = deleteOrder;

    /****** Delete Bulk Orders *******/
    this.deleteBulkOrders = function (orders, successCb) {
      var failures = [];
      deleteOrders(orders, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteOrders = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      deleteOrder(list[index].id, function (success) {
        deleteOrders(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        deleteOrders(list, index + 1, failures, successCb);
      });
    }

    /****** Get all orders ********/
    this.getOrders = function (params, successCb, failureCb) {
      if (params == null) {
        params = {};
      }
      if (params['status'] != null) {
        params['status'] = params['status'].toLowerCase();
      }

      /**** Setup scope - group or myDocketbook ****/
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseOrders = null;

      if (organisationGroup != null) {
        baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
      } else {
        baseOrders = Restangular.all('orders');
      }
      /**** End scope setup ****/

      if (params['offset'] != null && params['limit'] != null) {
        baseOrders.customGET("", params).then(successCb, failureCb);
      } else {
        baseOrders.getList(params).then(successCb, failureCb);
      }
    }

    /********** Parse Orders ************/
    var parseOrders = function (data) {
      var orders = [];
      data.forEach(function (order) {
        order.loading = false;
        order.status = order.status.charAt(0).toUpperCase() + order.status.slice(1);
        order.selected = false;
        orders.push(order);
      });

      return orders;
    }

    this.parseOrders = parseOrders;

    /******* Send order ********/
    var sendOrder = function (order, successCb, failureCb) {
      var orderId = order;
      if (order.id != null) {
        orderId = order.id;
      }
      var order = angular.copy(order);
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
      var orderObject = { status: 'sent' };
      baseOrders.one(orderId).customPUT(orderObject).then(successCb, failureCb)
    }

    this.sendOrder = sendOrder;

    /****** Send Bulk Orders *******/
    this.sendBulkOrders = function (orders, successCb) {
      var failures = [];
      sendOrders(orders, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var sendOrders = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      sendOrder(list[index].id, function (success) {
        sendOrders(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        sendOrders(list, index + 1, failures, successCb);
      });
    }

    /******* Re-Draft order ********/
    this.reDraftOrder = function (order, successCb, failureCb) {
      var orderId = order;
      if (order.id != null) {
        orderId = order.id;
      }
      var order = angular.copy(order);
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
      var orderObject = { status: 'draft' };
      baseOrders.one(orderId).customPUT(orderObject).then(successCb, failureCb)
    }

    /******** Reject order **********/
    var rejectOrder = function (order, successCb, failureCb) {
      var orderId = order;
      if (order.id != null) {
        orderId = order.id;
      }
      var order = angular.copy(order);
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
      var orderObject = { status: 'rejected' };
      baseOrders.one(orderId).customPUT(orderObject).then(successCb, failureCb);
    }

    this.rejectOrder = rejectOrder;

    /****** Reject Bulk Orders *******/
    this.rejectBulkOrders = function (orders, successCb) {
      var failures = [];
      rejectOrders(orders, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var rejectOrders = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      rejectOrder(list[index].id, function (success) {
        rejectOrders(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        rejectOrders(list, index + 1, failures, successCb);
      });
    }

    /******** Accept order **********/
    var acceptOrder = function (order, successCb, failureCb) {
      var orderId = order;
      if (order.id != null) {
        orderId = order.id;
      }
      var order = angular.copy(order);
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
      var orderObject = { status: 'Accepted' };
      // need to add org and org group is supplier
      var currentOrg = organisation;
      var currentOrgGroup = organisationGroup;
      if (!order.organisation || !order.organisationGroup) {
        if (currentOrgGroup.emailAddresses && order.supplierContact && order.supplierContact.contactAddresses) {
          var foundEmail = false;
          for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
            if (order.supplierContact.contactAddresses[currentOrgGroup.emailAddresses[i]] != null) {
              foundEmail = true;
              break;
            }
          }
          if (foundEmail) {
            orderObject.organisation = currentOrg.id;
            orderObject.organisationGroup = currentOrgGroup.id;
          }
        }
      }
      baseOrders.one(orderId).customPUT(orderObject).then(successCb, failureCb);
    }

    this.acceptOrder = acceptOrder;

    /****** Accept Bulk Orders *******/
    this.acceptBulkOrders = function (orders, successCb) {
      var failures = [];
      acceptOrders(orders, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var acceptOrders = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      acceptOrder(list[index].id, function (success) {
        acceptOrders(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        acceptOrders(list, index + 1, failures, successCb);
      });
    }

    /******** Close order **********/
    var closeOrder = function (order, successCb, failureCb) {
      var orderId = order;
      if (order.id != null) {
        orderId = order.id;
      }
      var order = angular.copy(order);
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
      var orderObject = { status: 'closed' };
      baseOrders.one(orderId).customPUT(orderObject).then(successCb, failureCb);
    }

    this.closeOrder = closeOrder;

    /****** Close Bulk Orders *******/
    this.closeBulkOrders = function (orders, successCb) {
      var failures = [];
      closeOrders(orders, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var closeOrders = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      closeOrder(list[index].id, function (success) {
        closeOrders(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        closeOrders(list, index + 1, failures, successCb);
      });
    }

    /***** Re-assign ORder *****/
    this.reassignOrderLineItems = function (order, losingOrderLineItem, gainingOrderLineItem, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseOrders = Restangular.all('orders');
      if (organisation != null && organisationGroup != null) {
        baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
      }

      var orderId = order;
      if (orderId.id != null) {
        orderId = orderId.id;
      }

      var payload = { 'losingOrderLineItemId': losingOrderLineItem.id, 'gainingOrderLineItemId': gainingOrderLineItem.id, 'gainingOrderLineItemDescription': gainingOrderLineItem.itemDescription };
      baseOrders.one(orderId).all('docket_lines').customPUT(payload).then(successCb, failureCb);
    }

    /***** Re-assign ORder *****/
    this.reassignOrder = function (order, losingPrincipal, gainingPrincipal, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseOrders = Restangular.all('orders');
      if (organisation != null && organisationGroup != null) {
        baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
      }

      var orderId = order;
      if (orderId.id != null) {
        orderId = orderId.id;
      }

      var payload = { 'losingPrincipal': losingPrincipal, 'gainingPrincipal': gainingPrincipal };
      baseOrders.one(orderId).all('reassign').customPOST(payload).then(successCb, failureCb);
    }

    /****** Create Shell Docket From Order *******/
    this.createDocketFromOrder = function (order, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

      var orderId = order;
      if (orderId.id != null) {
        orderId = orderId.id;
      }

      var shellDocket = { 'status': 'draft', 'authorName': accessControl.currentUser().name.full, 'author': accessControl.currentUser().id, 'organisation': organisation.id };
      shellDocket.date = moment().toISOString();
      // setup supplier contact from org group details
      var supplierContact = {};
      supplierContact.displayName = organisationGroup.publicName;
      supplierContact.contactAddresses = {};
      supplierContact.addresses = [];
      if (organisationGroup.address != null) {
        supplierContact.addresses.push(organisationGroup.address);
      }
      if (organisationGroup.emailAddress != null) {
        supplierContact.contactAddresses[organisationGroup.emailAddress] = [];
      }
      shellDocket.supplierContact = supplierContact;

      getOrder(orderId, function (orderFull) {
        shellDocket.template = orderFull.template;
        shellDocket.orderRef = orderId;
        if (orderFull.customerContact != null) {
          shellDocket.customerContact = orderFull.customerContact;
          /*var addressKeys = Object.keys(shellDocket.customerContact.contactAddresses);
          for ( var i = 0; i < addressKeys.length; i++ ) {
            if ( shellDocket.customerContact.contactAddresses[addressKeys[i]] == null || shellDocket.customerContact.contactAddresses[addressKeys[i]].length == 0 ) {
              shellDocket.customerContact.contactAddresses[addressKeys[i]] = ['approver'];
            }
          }*/
        }
        if (orderFull.supplierContact != null) {
          shellDocket.supplierContact = orderFull.supplierContact;
        }
        if (orderFull.supplierRefNo != null) {
          shellDocket.supplierRefNo = orderFull.supplierRefNo;
        }
        if (orderFull.customerRefNo != null) {
          shellDocket.customerRefNo = orderFull.customerRefNo;
        }

        // copy resources from order onto docket
        var copyItemsFromOrder = true;
        if (orderFull.lineItems && copyItemsFromOrder) {
          shellDocket.resources = [];
          for (var i = 0; i < orderFull.lineItems.length; i++) {
            var lineItem = orderFull.lineItems[i];
            var newResource = {};
            if (lineItem.resource) {
              newResource.resource = lineItem.resource;
              newResource.orderItemId = lineItem.id;
              newResource.name = lineItem.resource.name;
              newResource.description = lineItem.itemDescription;
              newResource.uniqueIdentifier = lineItem.supplierRef;
              shellDocket.resources.push(newResource);
            }
          }
        }

        baseDockets.post(shellDocket).then(successCb, failureCb);
      }, function (err) {
        failureCb('Could not get full order details to create docket from.');
      });
    }

    /**** Update Order Access Control *****/
    this.updateAccessControl = function (order, accessControlPayload, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseOrders = Restangular.all('orders');
      if (organisation != null && organisationGroup != null) {
        baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
      }

      var orderId = order;
      if (orderId.id != null) {
        orderId = orderId.id;
      }

      var accessControlFull = { 'accessControl': accessControlPayload };
      baseOrders.one(orderId).customPUT(accessControlFull).then(successCb, failureCb);
    }

    /****** Get Order Diff ******/
    this.getOrderDiff = function (original, modified, cb) {
      if (modified.id == null) {
        cb(modified, 0);
        return;
      }

      // check start/end date fields
      var diff = {};
      var diffCount = 0;
      if (!original.startDate && modified.startDate) {
        diff.startDate = modified.startDate;
        diffCount += 1;
      }
      if (original.startDate && modified.startDate && (original.startDate.getTime() != modified.startDate.getTime())) {
        diff.startDate = modified.startDate;
        diffCount += 1;
      }
      if (!original.endDate && modified.endDate) {
        diff.endDate = modified.endDate;
        diffCount += 1;
      }
      if (original.endDate && modified.endDate && (original.endDate.getTime() != modified.endDate.getTime())) {
        diff.endDate = modified.endDate;
        diffCount += 1;
      }
      // check docket template field
      if (!original.template && modified.template) {
        diff.template = modified.template;
        diffCount += 1;
      }
      if (original.template && modified.template && (original.template.id != modified.template.id)) {
        diff.template = modified.template;
        diffCount += 1;
      }
      // check docket prefill fields
      if (!original.docketPrefillValueStore && modified.docketPrefillValueStore) {
        diff.docketPrefillValueStore = modified.docketPrefillValueStore;
        diffCount += 1;
      }
      if (original.docketPrefillValueStore && modified.docketPrefillValueStore) {
        if (Object.keys(original.docketPrefillValueStore).length != Object.keys(modified.docketPrefillValueStore)) {
          diff.docketPrefillValueStore = modified.docketPrefillValueStore;
          diffCount += 1;
        } else {
          var valueStoreKeys = Object.keys(modified.docketPrefillValueStore);
          for (var i = 0; i < valueStoreKeys.length; i++) {
            if (modified.docketPrefillValueStore[valueStoreKeys[i]] != original.docketPrefillValueStore[valueStoreKeys[i]]) {
              diff.docketPrefillValueStore = modified.docketPrefillValueStore;
              diffCount += 1;
              break;
            }
          }
        }
      }
      // check if the ordernumber has been changed
      if (modified.orderNumber != original.orderNumber) {
        diff.orderNumber = modified.orderNumber;
        diffCount += 1;
      }
      // check supplier contact
      if (!original.supplierContact && modified.supplierContact) {
        diff.supplierContact = modified.supplierContact;
        diffCount += 1;
      }
      if (original.supplierContact && modified.supplierContact && original.supplierContact.id != modified.supplierContact.id) {
        diff.supplierContact = modified.supplierContact;
        diffCount += 1;
      }
      // check customer contact
      if (!original.customerContact && modified.customerContact) {
        diff.customerContact = modified.customerContact;
        diffCount += 1;
      }
      if (original.customerContact && modified.customerContact && original.customerContact.id != modified.customerContact.id) {
        diff.customerContact = modified.customerContact;
        diffCount += 1;
      }
      // check customer contact has been edited
      if (original.customerContact && modified.customerContact) {
        var originalContactAddresses = original.customerContact.contactAddresses;
        var modifiedContactAddresses = modified.customerContact.contactAddresses;
        var originalKeys = Object.keys(originalContactAddresses);
        var modifiedKeys = Object.keys(modifiedContactAddresses);
        var thisDiffed = false;
        if (originalKeys.length != modifiedKeys.length) {
          thisDiffed = true;
        } else {
          for (var i = 0; i < modifiedKeys.length; i++) {
            if (originalKeys.indexOf(modifiedKeys[i]) < 0) {
              thisDiffed = true;
              break;
            }
            if (JSON.stringify(modifiedContactAddresses[modifiedKeys[i]]) != JSON.stringify(originalContactAddresses[modifiedKeys[i]])) {
              thisDiffed = true;
              break;
            }
          }
        }

        if (thisDiffed) {
          diff.customerContact = modified.customerContact;
          diffCount += 1;
        }
      }

      // check line items
      if (!original.lineItems && modified.lineItems) {
        diff.lineItems = modified.lineItems;
        diffCount += 1;
      }
      if (original.lineItems && modified.lineItems) {
        var linesChanged = false;
        if (original.lineItems.length != modified.lineItems.length) {
          linesChanged = true;
        } else {
          for (var i = 0; i < modified.lineItems.length; i++) {
            if (modified.lineItems[i].quantityEdit) {
              var quantityEdit = parseFloat(modified.lineItems[i].quantityEdit);
              if (quantityEdit) {
                modified.lineItems[i].quantity = quantityEdit;
              }
            }
            if (modified.lineItems[i].delete == true) {
              linesChanged = true;
              break;
            }
            if (modified.lineItems[i].id != original.lineItems[i].id) {
              linesChanged = true;
              break;
            }
            if (modified.lineItems[i].itemDescription != original.lineItems[i].itemDescription) {
              linesChanged = true;
              break;
            }
            if ((modified.lineItems[i].resource && !original.lineItems[i].resource) || (!modified.lineItems[i].resource && original.lineItems[i].resource)) {
              linesChanged = true;
              break;
            }
            if (modified.lineItems[i].resource && original.lineItems[i].resource && modified.lineItems[i].resource.id != original.lineItems[i].resource.id) {
              linesChanged = true;
              break;
            }
            if (!original.lineItems[i].quantity && modified.lineItems[i].quantity) {
              linesChanged = true;
              break;
            }
            if (modified.lineItems[i].quantity && original.lineItems[i].quantity && modified.lineItems[i].quantity != original.lineItems[i].quantity) {
              linesChanged = true;
              break;
            }
            if (!original.lineItems[i].customerRef && modified.lineItems[i].customerRef) {
              linesChanged = true;
              break;
            }
            if (original.lineItems[i].customerRef && modified.lineItems[i].customerRef && original.lineItems[i].customerRef != modified.lineItems[i].customerRef) {
              linesChanged = true;
              break;
            }
            if (!original.lineItems[i].supplierRef && modified.lineItems[i].supplierRef) {
              linesChanged = true;
              break;
            }
            if (original.lineItems[i].supplierRef && modified.lineItems[i].supplierRef && original.lineItems[i].supplierRef != modified.lineItems[i].supplierRef) {
              linesChanged = true;
              break;
            }
            if (!original.lineItems[i].rate && modified.lineItems[i].rate) {
              linesChanged = true;
              break;
            }
            if (original.lineItems[i].rate && modified.lineItems[i].rate && original.lineItems[i].rate != modified.lineItems[i].rate) {
              linesChanged = true;
              break;
            }
          }
        }
        if (linesChanged) {
          diff.lineItems = modified.lineItems;
          diffCount += 1;
        }
      }
      // check customer and supplier reference numbers
      if (!original.customerRefNo && modified.customerRefNo) {
        diff.customerRefNo = modified.customerRefNo;
        diffCount += 1;
      }
      if (original.customerRefNo && modified.customerRefNo && original.customerRefNo != modified.customerRefNo) {
        diff.customerRefNo = modified.customerRefNo;
        diffCount += 1;
      }
      if (!original.supplierRefNo && modified.supplierRefNo) {
        diff.supplierRefNo = modified.supplierRefNo;
        diffCount += 1;
      }
      if (original.supplierRefNo && modified.supplierRefNo && original.supplierRefNo != modified.supplierRefNo) {
        diff.supplierRefNo = modified.supplierRefNo;
        diffCount += 1;
      }
      // check notes field
      if (!original.notes && modified.notes) {
        diff.notes = modified.notes;
        diffCount += 1;
      }
      if (original.notes && modified.notes && original.notes != modified.notes) {
        diff.notes = modified.notes;
        diffCount += 1;
      }
      if (original.notes && !modified.notes) {
        diff.notes = "";
        diffCount += 1;
      }
      // check status
      if (original.status != modified.status) {
        diff.status = modified.status;
        diffCount += 1;
      }
      diff.id = modified.id;
      cb(diff, diffCount);
    }

    /** Validation Parameters **/
    // Lists the required fields for each action on the order and their respective type
    var validationParameters = {
      'sendOrderCustomer': { 'startDate': 'string', 'endDate': 'string', 'lineItems': 'array' },
      'sendOrderSupplier': { 'startDate': 'string', 'endDate': 'string', 'template': 'string', 'lineItems': 'array', 'customerContact': 'string' },
      'acceptOrderCustomer': {},
      'acceptOrderSupplier': { 'template': 'string' },
      'rejectOrder': {},
      'createJobFromOrder': { 'template': 'string' }
    };

    var niceFieldDisplays = {
      'startDate': 'Start Date',
      'endDate': 'End Date',
      'lineItems': 'Items',
      'template': 'Docket Template',
      'customerContact': 'Customer Contact'
    };

    var checkRequiredParameters = function (order, parameters, successCb, failureCb) {
      var exceptions = [];
      var paramsKeys = Object.keys(parameters);
      for (var i = 0; i < paramsKeys.length; i++) {
        var thisParam = paramsKeys[i];
        if (parameters[thisParam] == 'string' && (order[thisParam] == null || order[thisParam] == "")) {
          if (niceFieldDisplays[thisParam] != null) {
            exceptions.push(niceFieldDisplays[thisParam]);
          } else {
            exceptions.push(thisParam);
          }
        } else if (parameters[thisParam] == 'array' && (order[thisParam] == null || order[thisParam].length <= 0)) {
          if (niceFieldDisplays[thisParam] != null) {
            exceptions.push(niceFieldDisplays[thisParam]);
          } else {
            exceptions.push(thisParam);
          }
        }
      }

      if (exceptions.length > 0) {
        failureCb(exceptions);
      } else {
        successCb();
      }
    }

    /* Send Order Validation Helper */
    this.validateSendOrder = function (order, successCb, failureCb) {
      // check if customer or supplier sending the order
      var validateParams = [];
      if (userService.userCanDoAction('isOrderSupplier', order)) {
        validateParams = validationParameters['sendOrderSupplier'];
      } else {
        validateParams = validationParameters['sendOrderCustomer'];
      }

      checkRequiredParameters(order, validateParams, successCb, failureCb);
    }

    /* Accept Order Validation Helper */
    this.validateAcceptOrder = function (order, successCb, failureCb) {
      // check if customer or supplier accepting the order
      var validateParams = [];
      if (userService.userCanDoAction('isOrderSupplier', order)) {
        validateParams = validationParameters['acceptOrderSupplier'];
      } else {
        validateParams = validationParameters['acceptOrderCustomer'];
      }

      checkRequiredParameters(order, validateParams, successCb, failureCb);
    }

    /* Create Job From Order Validation Helper */
    this.validateCreateJob = function (order, successCb, failureCb) {
      // check if customer or supplier accepting the order
      var validateParams = validationParameters['createJobFromOrder'];
      checkRequiredParameters(order, validateParams, successCb, failureCb);
    }

  });



// WEBPACK FOOTER //
// ./src/services/orderService.js